<template>
    <div class="repast">
        <Swiper class="theme_img" v-if="imagePath.length > 0" duration="1000">
            <Slide v-for="(item,index) in imagePath" :key="index">
                <img :src="weburl+item" alt="">
            </Slide>
        </Swiper>
        <div v-for="(n, i) in repastImgLists" :key="i" @click="ChangeShow(i)">
            <img :src="n" :alt="$t('nav.restaurant')">
        </div>
    </div>
</template>

<script>
import { Swiper, Slide } from "vue-swiper-component";

export default {
  name: "repast",
  components: {
    Swiper,
    Slide
  },
  inject: ["showMsg"],
  data: function() {
    return {
      imagePath: [],
      repastImgLists: [
        require("../../assets/images/repast/repast_1.jpg"),
        require("../../assets/images/repast/repast_2.jpg"),
        require("../../assets/images/repast/repast_3.jpg"),
        require("../../assets/images/repast/repast_4.jpg")
      ]
    };
  },
  created() {
    this.carousel();
    this.$store.commit("set_current", 2);
    this.$store.commit("set_title", "nav.restaurant");
  },
  methods: {
    ChangeShow(i) {
      const id = parseInt(i) + 1;
      this.$router.push({
        path: `/ChineseRepast`,
        query: {
          show_id: id.toString()
        }
      });
    },
    carousel() {
      //    获取数据的方法

      switch (this.$i18n.locale) {
        case "en":
          this.repastImgLists = [
            require("../../assets/images/lang/en/repast01.jpg"),
            require("../../assets/images/lang/en/repast02.jpg"),
            require("../../assets/images/lang/en/repast03.jpg"),
            require("../../assets/images/lang/en/repast04.jpg")
          ];
          break;
        case "kor":
          this.repastImgLists = [
            require("../../assets/images/lang/kor/repast01.jpg"),
            require("../../assets/images/lang/kor/repast02.jpg"),
            require("../../assets/images/lang/kor/repast03.jpg"),
            require("../../assets/images/lang/kor/repast04.jpg")
          ];
          break;
        case "jap":
          this.repastImgLists = [
            require("../../assets/images/lang/jap/repast01.jpg"),
            require("../../assets/images/lang/jap/repast02.jpg"),
            require("../../assets/images/lang/jap/repast03.jpg"),
            require("../../assets/images/lang/jap/repast04.jpg")
          ];
          break;
      }
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + "/home/Repast/getRepast",
        dataType: "json",
        data: {
          repast_id: 1,
          lang: window.$lang
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.imagePath = res.data.result.mobile_url.filter(item => item);
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    }
  },
  computed: {
    //计算属性，
    repast_list: function() {
      return this.$store.state.food.repast_list;
    },
    weburl: function() {
      return this.$store.state.weburl;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common.less";

.repast {
  width: @width;
  background: @bg;
  padding-bottom: 1px;
  .theme_img {
    width: @width;
      img {
      .img;
      vertical-align: bottom;
    }
  }
  & > div {
    width: @width;
    margin-bottom: 10px;
    img {
      .img;
      vertical-align: bottom;
    }
  }

  /*w:750;h:630px*/
}
</style>
